module.exports = __webpack_public_path__ + "img/goout.0f6354b2.png";